/**
 * Cut string for the given length and append ... if string is larger than the given length
 *
 */
function readMoreChars(string, length, readMoreDots = "...") {
    if (!string)
        return "";
    if (string.length <= length)
        return string;
    return string.substring(0, length) + readMoreDots;
}export{readMoreChars as default};